import { createFileRoute } from '@tanstack/react-router';
import { useMinWidth } from '@tupai/shell';
import ChildHomeworkPage from '@/components/child-homework-page';
import ChildHubPage from '@/components/child-hub-page';

// From `lg` the same URL renders the hub with the full homework list in place.
export const Route = createFileRoute('/_protected/children/$linkId/homework/')({
  component: ChildHomeworkRoute,
});

function ChildHomeworkRoute() {
  const isLg = useMinWidth('lg');
  return isLg ? <ChildHubPage section="homework" /> : <ChildHomeworkPage />;
}
